module.exports = __webpack_public_path__ + "img/header_1.9799ef48.png";